import React from 'react';
import { Modal } from 'react-bootstrap';
import FeaturedPlayListForm from '../FeaturedPlayListForm';

export function FeaturedPlaylistModal({ showModal, setModalShow, handleClose, editPlaylistID }) {
	return (
		<Modal show={showModal} onHide={handleClose} className="add__modal">
			<Modal.Header closeButton>
				<Modal.Title>{editPlaylistID ? 'Edit Playlist' : 'Add New Playlist'}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FeaturedPlayListForm show={showModal} setShow={setModalShow} editPlaylistID={editPlaylistID} />
			</Modal.Body>
		</Modal>
	);
}
